import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "NewsArticle",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getNewsArticle, getNewsArticleError, getNewsArticleSuccess } =
  slice.actions;

reducerRegistry.register("newsArticle", reducer);
